<template>
  <div v-if="result.mfa && result.mfa.resendCodeIn">
    <div v-if="resendCodeIn > 0">
      You can request a new code in <strong>{{ timeLeft }}</strong>
    </div>
    <async-btn
      v-else
      :task="task"
      icon="fa fa-refresh"
      label="Didn't receive code? Resend code"
      flat
      no-caps
      rounded
      @click="resendCode"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { HasTaskMixin } from '@/mixins';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { resendSmsAuthCode, LoginResult } from '.';

interface Data {
  task: Promise<LoginResult>|null,
  timerId: ReturnType<typeof setInterval>|null,
  resendCodeIn: number|null
}

export default defineComponent({
  emits: ['result'],
  components: { AsyncBtn },
  mixins: [HasTaskMixin],
  props: {
    sessionId: {
      type: String,
      required: true,
    },
    result: {
      type: Object as () => LoginResult,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
      timerId: null,
      resendCodeIn: null,
    };
  },
  computed: {
    timeLeft(): string {
      if (!this.resendCodeIn) return '0:00';
      const mins = Math.floor(this.resendCodeIn / 60);
      const secs = this.resendCodeIn % 60;
      return `${mins}:${secs}`;
    },
  },
  watch: {
    result: {
      handler(result: LoginResult) {
        if (result.mfa && result.mfa.resendCodeIn) {
          this.resendCodeIn = result.mfa.resendCodeIn;
          this.countdown();
        }
      },
      immediate: true,
    },
  },
  methods: {
    countdown() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }

      const countdown = () => {
        if (!this.resendCodeIn) return;
        this.resendCodeIn -= 1;
        if (this.resendCodeIn > 0) {
          this.timerId = setTimeout(countdown, 1000);
        }
      };
      countdown();
    },
    resendCode() {
      this.task = resendSmsAuthCode(this.sessionId);
      this.task.then((result) => {
        this.$emit('result', result);
      });
    },
  },
});
</script>
